window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // Popper
    window.Popper = require('popper.js').default;

    // Bootstrap
    window.Bootstrap = require('bootstrap');
} catch (e) {}

// Validation
window.JustValidate = require('just-validate');
window.JustValidateLocale = require('./locales/locale-validate');

// PNotify
window.PNotifyFontAwesome4 = require('@pnotify/font-awesome4');
window.Pnotify = require('@pnotify/core');
Pnotify.defaultModules.set(PNotifyFontAwesome4, {});

// Filepond
window.Filepond = require('filepond');
window.FilepondLocale = require('./locales/lt_en_locale_filepond');

Filepond.registerPlugin(
    require('filepond-plugin-file-validate-size'),
    require('filepond-plugin-file-validate-type'),
    require('filepond-plugin-image-validate-size'),
    require('filepond-plugin-file-encode')
);

// Air Datepicker
window.AirDatepicker = require('air-datepicker/air-datepicker');
window.airDatePickerLocaleLT = require('./locales/lt-locale-air-datepicker').default;
window.airDatePickerLocaleEN = require('air-datepicker/locale/en').default;

// Slim Select
window.SlimSelect = require('slim-select');

// Initialize Simplebar
window.SimpleBar = require('simplebar').default;

// Common scripts and components should be imported at the end
// Common script files
window.Helper = require('./components/helpers');
window.Fnc = require('./components/functions');
window.Init = require('./components/init');
window.Validate = require('./components/validate');

